export default {
  examList: state => state.examList
}
